import React from 'react';
import { Anchor, Icons } from '@miro-site/ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
export var SocialMediaLinks = function SocialMediaLinks(_ref) {
  var socialMediaLinks = _ref.socialMediaLinks;
  return /*#__PURE__*/_jsx("span", {
    className: "d-flex justify-content-center gap-300",
    children: socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.map(function (socialMediaLink) {
      var SocialMediaIcon = (Icons === null || Icons === void 0 ? void 0 : Icons[socialMediaLink.icon]) || Icons.Placeholder;
      return /*#__PURE__*/_jsx(Anchor, {
        href: socialMediaLink.href,
        title: socialMediaLink.label,
        children: /*#__PURE__*/_jsx(SocialMediaIcon, {
          size: "lg"
        })
      }, socialMediaLink.href);
    })
  });
};